import {
  resolve
} from "@/components/charts/common";



export default async function hydrator(parameters, data, chart) {

  chart.data = {};

  chart.data.tableName = resolve("tableName.value", parameters);

  let parameterisedFilterObject = resolve("tree.parameterisedFilterObject", chart, {});

  if(typeof parameterisedFilterObject._id != "undefined" && parameterisedFilterObject._id) {
    chart.data.id = parameterisedFilterObject._id;
  }

}
